(function() {
  function updateCartBubble(count) {
    var countEls = document.querySelectorAll('.cart-link__bubble-num');
    var bubbles = document.querySelectorAll('.cart-link__bubble');

    countEls.forEach(function(el) {
      el.innerText = count;
    });

    bubbles.forEach(function(bubble) {
      if (count > 0) {
        bubble.classList.add('cart-link__bubble--visible');
      } else {
        bubble.classList.remove('cart-link__bubble--visible');
      }
    });
  }

  function refreshThemeCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  document.addEventListener('rebuy:cart.change', function(event) {
    var rebuyCart = event.detail &&
      event.detail.cart &&
      event.detail.cart.cart;

    if (rebuyCart && typeof rebuyCart.item_count === 'number') {
      updateCartBubble(rebuyCart.item_count);
    } else if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
      theme.cart.getCart().then(function(cart) {
        updateCartBubble(cart.item_count || 0);
      });
    }

    refreshThemeCartDrawer();
  });
})();